export default class IssuesFeatures {

    constructor(router, auth) {
        this.router = router
        this.auth = auth
    }

    // Navigation.

    openIssues() {
        this.router.push({ name: 'dashboard-issues' })
    }

    openSimulationIssues(registration, simulation) {
        this.router.push({ name: 'dashboard-simulation-issues', params: {
            registrationId: registration.id,
            simulationId: simulation.id,
        } })
        return true
    }

    
    // Local vs remote data mapping.
    
    mapData(registration) {
        return {
            id: registration ? registration.id : null,

            cohort: registration ? registration.cohort : null,
            cohort_id: registration ? registration.cohort_id : null,

            degree: registration ? registration.degree : null,
            degree_id: registration ? registration.degree_id : null,

            simulations: registration ? registration.simulations : null,
        }
    }

    unmapData(data) {
        return {...data}
    }
}
